import React from 'react';

import Layout from '../components/layout';
import LinkBox from '../components/link-box';
import SEO from '../components/seo';
import robot from '../assets/undraw_fixing_bugs.svg';

export default function NotFoundPage() {
  return (
    <Layout>
      <SEO title="Page not found" />
      <div className="grid grid-cols-1 gap-2 place-items-center mt-20">
        <h2 className="mt-3 tracking-wide">404</h2>
        <p className="mt-2 mb-8 leading-relaxed">
          The page you are looking for doesn't exist.
        </p>
        <img src={robot} alt="Fixing bug" width="400" className="mb-10" />
        <div className="mb-28 flex flex-wrap gap-3">
          <LinkBox href="/">Visit Home</LinkBox>
          <LinkBox href={`/random`}>Random episode</LinkBox>
        </div>
      </div>
    </Layout>
  );
}
